import React, { useState } from "react";
import "../styles/CadastroUsuario.css";
import "../styles/global.css";
import { cpf } from "cpf-cnpj-validator";
import { Eye, EyeOff } from "lucide-react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const CadastroUsuario = ({ idCliente, tipoUsuario = "Administrador do Cliente" }) => {
  const { clienteId } = useParams();
  const [formData, setFormData] = useState({
    nome_completo: "",
    cpf: "",
    genero: "",
    data_nascimento: "",
    email: "",
    telefone: "",
    cargo: "",
    usuario: "",
    senha: "",
    confirmar_senha: "",
    tipo: tipoUsuario,
    cliente_id: clienteId || idCliente || ""
  });

  const [errors, setErrors] = useState({});
  const [sucesso, setSucesso] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false);
  const navigate = useNavigate();

  const aplicarMascara = (campo, valor) => {
    const somenteNumeros = valor.replace(/\D/g, "");
    switch (campo) {
      case "cpf":
        return somenteNumeros.slice(0, 11)
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      case "telefone":
        return somenteNumeros.slice(0, 11)
          .replace(/(\d{2})(\d)/, "($1) $2")
          .replace(/(\d{5})(\d)/, "$1-$2");
      default:
        return valor;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const mascarado = ["cpf", "telefone"].includes(name) ? aplicarMascara(name, value) : value;
    setFormData({ ...formData, [name]: mascarado });
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const validarCampo = (name, value) => {
    let erro = "";
  
    if (name === "cpf") {
      const cpfLimpo = value.replace(/\D/g, "");
  
      if (!cpfLimpo || cpfLimpo.length === 0) {
        erro = "obrigatorio";
      } else if (!cpf.isValid(cpfLimpo)) {
        erro = "invalido";
      }
    }
  
    setErrors((prev) => ({ ...prev, [name]: erro }));
  };
  

  const validarFormulario = () => {
    const obrigatorios = ["nome_completo", "cpf", "email", "telefone", "usuario", "senha", "confirmar_senha"];
    const novosErros = {};

    obrigatorios.forEach((campo) => {
      if (!formData[campo] || formData[campo].trim() === "") {
        novosErros[campo] = "obrigatorio";
      }
    });

    if (formData.cpf && !cpf.isValid(formData.cpf)) {
      novosErros.cpf = "invalido";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      novosErros.email = "invalido";
    }

    if (formData.senha !== formData.confirmar_senha) {
      novosErros.confirmar_senha = "diferente";
    }

    setErrors(novosErros);
    return Object.keys(novosErros).length === 0;
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validarFormulario()) return;

  try {
    const payload = {
      ...formData,
      cpf: formData.cpf.replace(/\D/g, ""),
      data_nascimento: formData.data_nascimento === "" ? null : formData.data_nascimento
    };
    
    
    const response = await fetch("http://localhost:5000/api/usuarios/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
    

    if (response.ok) {
      setSucesso(true);
    
      setTimeout(() => {
        setSucesso(false);
        navigate("/clientes");
      }, 2000);
    }
    
  } catch (error) {
    console.error("Erro de conexão:", error);
    alert("Erro de conexão com o servidor.");
  }
};


  const renderErro = (campo) => {
    if (!errors[campo]) return null;
    if (campo === "cpf") {
      if (errors.cpf === "invalido") return <span className="campo-erro">CPF inválido</span>;
      if (errors.cpf === "obrigatorio") return <span className="campo-erro">Obrigatório</span>;
    }
        if (campo === "email" && errors.email === "invalido") return <span className="campo-erro">Email inválido</span>;
    if (campo === "confirmar_senha" && errors.confirmar_senha === "diferente") return <span className="campo-erro">Senhas não conferem</span>;
    return <span className="campo-erro">Obrigatório</span>;
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Cadastro de Usuário</h2>
      <form onSubmit={handleSubmit}>
        {sucesso && <div className="sucesso-msg">Usuário cadastrado com sucesso!</div>}

        {/* CPF + Nome Completo */}
        <div className="form-row">
          <div className={`form-group campo-cpf ${errors.cpf ? 'erro' : ''}`} style={{ width: '160px', flex: 'none' }}>
            <label>CPF</label>
            <input type="text" name="cpf" value={formData.cpf} onChange={handleChange}  onBlur={(e) => validarCampo(e.target.name, e.target.value)}
              placeholder="000.000.000-00" />
            {renderErro("cpf")}
          </div>
          <div className={`form-group ${errors.nome_completo ? 'erro' : ''}`} style={{ flex: 1 }}>
            <label>Nome Completo</label>
            <input type="text" name="nome_completo" value={formData.nome_completo} onChange={handleChange} />
            {renderErro("nome_completo")}
          </div>
        </div>

        {/* Gênero + Data + Cargo */}
        <div className="form-row">
          <div className="form-group campo-genero" style={{ width: '210px', flex: 'none' }}>
            <label>Gênero</label>
            <select name="genero" value={formData.genero} onChange={handleChange}>
              <option value="">Selecione</option>
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
              <option value="Não binário">Não binário</option>
              <option value="Prefiro não informar">Prefiro não informar</option>
            </select>
          </div>
          <div className="form-group campo-data" style={{ width: '160px', flex: 'none' }}>
            <label>Data de Nascimento</label>
            <input type="date" name="data_nascimento" value={formData.data_nascimento} onChange={handleChange} />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Cargo/Função</label>
            <input type="text" name="cargo" value={formData.cargo} onChange={handleChange} />
          </div>
        </div>

        {/* Telefone + Email */}
        <div className="form-row">
          <div className={`form-group campo-telefone ${errors.telefone ? 'erro' : ''}`} style={{ width: '180px', flex: 'none' }}>
            <label>Telefone</label>
            <input type="text" name="telefone" value={formData.telefone} onChange={handleChange} placeholder="(00) 00000-0000" />
            {renderErro("telefone")}
          </div>
          <div className={`form-group ${errors.email ? 'erro' : ''}`} style={{ flex: 1 }}>
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} />
            {renderErro("email")}
          </div>
        </div>

        {/* Usuário + Senha + Confirmar Senha */}
        <div className="form-row">
          <div className={`form-group campo-usuario ${errors.usuario ? 'erro' : ''}`} style={{ width: '220px', flex: 'none' }}>
            <label>Usuário (login)</label>
            <input type="text" name="usuario" value={formData.usuario} onChange={handleChange} />
            {renderErro("usuario")}
          </div>
          <div className={`form-group campo-senha ${errors.senha ? 'erro' : ''}`} style={{ width: '220px', flex: 'none', position: 'relative' }}>
            <label>Senha Provisória</label>
            <input type={mostrarSenha ? "text" : "password"} name="senha" value={formData.senha} onChange={handleChange} />
            <span className="toggle-password" onClick={() => setMostrarSenha(!mostrarSenha)}>{mostrarSenha ? <EyeOff size={16} /> : <Eye size={16} />}</span>
            {renderErro("senha")}
          </div>
          <div className={`form-group ${errors.confirmar_senha ? 'erro' : ''}`} style={{ width: '220px', flex: 'none', position: 'relative' }}>
            <label>Confirmar Senha</label>
            <input type={mostrarConfirmar ? "text" : "password"} name="confirmar_senha" value={formData.confirmar_senha} onChange={handleChange} />
            <span className="toggle-password" onClick={() => setMostrarConfirmar(!mostrarConfirmar)}>{mostrarConfirmar ? <EyeOff size={16} /> : <Eye size={16} />}</span>
            {renderErro("confirmar_senha")}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group campo-tipo" style={{ width: '220px', flex: 'none' }}>
            <label>Tipo de Usuário</label>
            <input type="text" value={formData.tipo} disabled />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
        </div>
      </form>
    </div>
  );
};

export default CadastroUsuario;
